import { render, staticRenderFns } from "./ContentsListNoImage.vue?vue&type=template&id=ef297e08"
import script from "./ContentsListNoImage.vue?vue&type=script&lang=js"
export * from "./ContentsListNoImage.vue?vue&type=script&lang=js"
import style0 from "./ContentsListNoImage.vue?vue&type=style&index=0&id=ef297e08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports